import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export type TipoOrigemMedicao = 'ppu' | 'eap' | 'ubs';

export interface SaldoMedicaoItem {
  planilha_item_id: string;
  versao_id: string | null;
  codigo_item: string;
  descricao: string;
  unidade: string;
  quantidade_contratada: number;
  preco_unitario: number;
  valor_total: number;
  qtd_executada_acumulada: number;
  saldo_disponivel: number;
  qtd_medida_acumulada: number;
  saldo_contratual: number;
  flag_execucao_maior_que_contratado: boolean;
  tipo_origem: TipoOrigemMedicao;
  cronograma_atividade_id: string | null;
  os_item_id: string | null;
  contrato_id_direto: string | null;
}

export function useEmpSaldoMedicao(versaoId: string | null) {
  return useQuery({
    queryKey: ['emp-saldo-medicao', versaoId],
    queryFn: async () => {
      if (!versaoId) return [];
      const { data, error } = await supabase
        .from('emp_vw_saldo_medicao' as any)
        .select('*')
        .eq('versao_id', versaoId);
      if (error) throw error;
      return (data as unknown as SaldoMedicaoItem[]) ?? [];
    },
    enabled: !!versaoId,
  });
}
